import { createContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";

export const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const token = useSelector((state) => state.userInfo?.token);
  const socketRef = useRef(null);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!token) {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
        setSocket(null);
      }
      return;
    }

    const apiUrl = new URL(process.env.REACT_APP_PUBLIC_URL);
    const serverUrl = `${apiUrl.protocol}//${apiUrl.host}`;
    const socketPath = `${apiUrl.pathname}/socket.io`;

    const newSocket = io(serverUrl, {
      path: socketPath,
      query: { token },
      reconnectionAttempts: 5,
    });

    socketRef.current = newSocket;
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
      socketRef.current = null;
    };
  }, [token]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
}
